<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parkcredential_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/park/credential/parkcredential';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        column: [
          {
            label: '',
            prop: 'id',
            rules: [
              {
                required: true,
                message: '请输入',
                trigger: 'change',
              },
            ],
          },
          {
            label: '服务ID：更新注销新增等唯一识别',
            prop: 'serviceId',
            rules: [
              {
                required: true,
                message: '请输入服务ID：更新注销新增等唯一识别',
                trigger: 'change',
              },
            ],
          },
          {
            label: '服务生效的车场ID',
            prop: 'parkingLotId',
            rules: [
              {
                required: true,
                message: '请输入服务生效的车场ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车主ID',
            prop: 'driverId',
            rules: [
              {
                required: true,
                message: '请输入车主ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆ID',
            prop: 'vehicleId',
            rules: [
              {
                required: true,
                message: '请输入车辆ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆类型：:字典值',
            prop: 'vehicleType',
            rules: [
              {
                required: true,
                message: '请输入车辆类型：:字典值',
                trigger: 'change',
              },
            ],
          },
          {
            label: '操作类型：枚举值OPEN：开通,RECHARGE：延期,REFUND：退款,UPDATE：更新 ，必填',
            prop: 'operateType',
            rules: [
              {
                required: true,
                message:
                  '请输入操作类型：枚举值OPEN：开通,RECHARGE：延期,REFUND：退款,UPDATE：更新 ，必填',
                trigger: 'change',
              },
            ],
          },
          {
            label: '服务开始时间',
            prop: 'startTime',
            rules: [
              {
                required: true,
                message: '请输入服务开始时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '服务结束时间',
            prop: 'endTime',
            rules: [
              {
                required: true,
                message: '请输入服务结束时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '服务凭证类型:1车牌',
            prop: 'credentialType',
            rules: [
              {
                required: true,
                message: '请输入服务凭证类型:1车牌',
                trigger: 'change',
              },
            ],
          },
          {
            label: '服务凭证号：服务凭证类型为1时，此值为车牌号',
            prop: 'credentialNo',
            rules: [
              {
                required: true,
                message: '请输入服务凭证号：服务凭证类型为1时，此值为车牌号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '凭证有效通行区域（多个使用逗号隔开）',
            prop: 'regionIds',
            rules: [
              {
                required: true,
                message: '请输入凭证有效通行区域（多个使用逗号隔开）',
                trigger: 'change',
              },
            ],
          },
          {
            label: '凭证有效通行设备(多个使用逗号隔开)',
            prop: 'deviceIds',
            rules: [
              {
                required: true,
                message: '请输入凭证有效通行设备(多个使用逗号隔开)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '套餐编号',
            prop: 'setmealNo',
            rules: [
              {
                required: true,
                message: '请输入套餐编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '同步状态：1未同步2同步成功3同步异常',
            prop: 'syncStatus',
            rules: [
              {
                required: true,
                message: '请输入同步状态：1未同步2同步成功3同步异常',
                trigger: 'change',
              },
            ],
          },
          {
            label: '同步说明',
            prop: 'syncRemark',
            rules: [
              {
                required: true,
                message: '请输入同步说明',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            rules: [
              {
                required: true,
                message: '请输入备注信息',
                trigger: 'change',
              },
            ],
          },
          {
            label: '版本',
            prop: 'version',
            rules: [
              {
                required: true,
                message: '请输入版本',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkcredential_add, false),
        viewBtn: this.vaildData(this.permission.parkcredential_view, false),
        delBtn: this.vaildData(this.permission.parkcredential_delete, false),
        editBtn: this.vaildData(this.permission.parkcredential_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
